import 'bootstrap';



// WEBPACK FOOTER //
// resources/assets/scripts/autoload/_bootstrap.js